import axios from 'axios';

/* Every request to our API carries the login token (if someone is logged in),
   so the server can check who is asking. Requests that already set
   their own Authorization header keep it. */
const API = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/$/, '');

axios.interceptors.request.use((config) => {
  try {
    const url = String(config.url || '');
    const ours = API ? url.startsWith(API) : url.startsWith('/api/');
    if (!ours) return config;
    const token = localStorage.getItem('userData');
    if (!token || token === 'null' || token === 'undefined') return config;
    const has = config.headers && (config.headers.Authorization || config.headers.authorization ||
      (typeof config.headers.get === 'function' && config.headers.get('Authorization')));
    if (!has) {
      if (config.headers && typeof config.headers.set === 'function') config.headers.set('Authorization', `Bearer ${token}`);
      else config.headers = { ...(config.headers || {}), Authorization: `Bearer ${token}` };
    }
  } catch {
    /* storage blocked: send the request as it is */
  }
  return config;
});
